import { useState, useEffect } from 'react';

import { useLoggedInUser } from '../../../../utils/logged-in-user-provider';

export const useMobileNavDisplay = (isOpenSearch: boolean) => {
	const userInfo = useLoggedInUser();
	const [showMenu, setShowMenu] = useState(false);
	const [isDisplayLoggedInUseDropdown, setIsDisplayLoggedInUseDropdown] = useState(false);
	const [firstOpen, setFirstOpen] = useState(false);
	const [menuPage, setMenuPage] = useState('default');

	const handleToggleMenu = (showMenu: boolean) => {
		setShowMenu(showMenu);
		if (isDisplayLoggedInUseDropdown) {
			setIsDisplayLoggedInUseDropdown(false);
		}
	};

	const handleFirstOpen = (firstOpen: boolean) => {
		setFirstOpen(firstOpen);
	};

	const handleMenuPage = (menuPage: string) => {
		setMenuPage(menuPage);
	};

	const handleClickAvatar = () => {
		if (!isDisplayLoggedInUseDropdown && showMenu) {
			setIsDisplayLoggedInUseDropdown(
				(isDisplayLoggedInUseDropdown) => !isDisplayLoggedInUseDropdown,
			);
		} else {
			setIsDisplayLoggedInUseDropdown(
				(isDisplayLoggedInUseDropdown) => !isDisplayLoggedInUseDropdown,
			);
			setShowMenu((showMenu) => !showMenu);
		}
	};

	useEffect(() => {
		if (isOpenSearch) {
			setShowMenu(false);
			setFirstOpen(false);
			setIsDisplayLoggedInUseDropdown(false);
		}
	}, [isOpenSearch]);

	return {
		userInfo,
		showMenu,
		isDisplayLoggedInUseDropdown,
		firstOpen,
		menuPage,
		handleToggleMenu,
		handleFirstOpen,
		handleMenuPage,
		handleClickAvatar,
	};
};
